var map = {
	"./assets/clickable/shopify.svg": "a6972105f9b98066d68f",
	"./assets/disabled/shopify.svg": "3af40c544c214f32f09b",
	"./assets/original/shopify.svg": "316ceeab143a38a99de7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2aef239d92716cb2346e";